import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/game/mobile_singalGzh.png'


const _withScopeId = n => (_pushScopeId("data-v-cf68c376"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "tab" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "首页", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = { class: "wechatAccount" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))

import { onMounted, reactive, ref } from "vue";
import { storeToRefs } from "pinia";

import { useGameStore } from "../../../store/gameStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const state: any = reactive({
  moreInfoFlag: false,
  down: [],
  gameslide: [],
  lists: [],
  rmgames: [],
  accountShow: false,
});
let gameStore = useGameStore();

const { downStore } = storeToRefs(gameStore);

onMounted(() => {
  // console.log("onmounted------------");
  // getInfo();
});

const openAccount = () => {
  state.accountShow = !state.accountShow;
};
const fullScreenClick = () => {
  state.accountShow = false;
};
const goWechat=()=>{
  // console.log(downStore.value)
    window.location.href = downStore.value.lxkf
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "allContent",
    onClick: _withModifiers(fullScreenClick, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_tabbar, {
        route: "",
        fixed: "",
        "active-color": "#FEBF13",
        "inactive-color": "#666666"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tabbar_item, { to: "/mobileView/homePage" }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_van_tabbar_item, { to: "/mobileView/gameCenter" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" 游戏 ")
            ]),
            _: 1
          }),
          _createVNode(_component_van_tabbar_item, {
            onClick: _withModifiers(openAccount, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" 公众号 "),
              _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_11, 512), [
                [_vShow, state.accountShow]
              ])
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_van_tabbar_item, { onClick: goWechat }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createTextVNode(" 客服 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 8, _hoisted_1))
}
}

})